import {ActionReducerMap} from '@ngrx/store';
import {appReducer} from './app/app.reducer';
import {authReducer} from './auth/auth.reducer';
import {organisationReducer} from './organisation/organisation.reducer';
import {permissionsReducer} from './permissions/permission.reducer';

export const appReducers: ActionReducerMap<any> = {
  app: appReducer,
  auth: authReducer,
  organisation: organisationReducer,
  permissions: permissionsReducer
};
